import useSWR from "swr";
import { User } from "@prisma/client";
import { parse } from "cookie";

const fetcher = async (url: string) => {
  const isLoggedOut = getLoggedOutCookie(document.cookie);
  if (isLoggedOut === 1) {
    return { user: null };
  } else {
    return fetch(url).then(async (res) => {
      if (res.status === 401) {
        const error = new Error("Not authorized!");
        // @ts-ignore
        error.status = 401;
        throw error;
      } else {
        const user = await res.json();
        return { user: user ?? null };
      }
    });
  }
};
const getLoggedOutCookie = (cookies: string) => {
  const cookie = parse(cookies || "");
  if (cookie["loggedOut"]) {
    return parseInt(cookie["loggedOut"]);
  }
  return 1;
};

export const useUser = () => {
  const { data, mutate, error, isValidating, revalidate } = useSWR(
    "/api/user",
    fetcher
  );
  const loading = !data && !error;
  const loggedOut =
    (!!error && error.status === 401) || (data && data.user === null);
  const user: User | null = error ? null : data ? data.user : null;
  return {
    loading,
    loggedOut,
    error,
    user,
    mutate,
  };
};
